export default __webpack_public_path__ + "static/media/testimony_student_five.c4d94cf5.png";